<template>
  <div class="header-wrapper">
    <layout-header-bar />
    <div class="header-wrapper-inner">
      <div class="w-[90px] md:hidden">
        <button type="button" class="block" @click="goNewQuote">
          <img
            src="/images/quote-icon.svg"
            alt="New Quote CTA"
            class="h-14"
          />
        </button>
      </div>
      <button type="button" @click="goHome">
        <img
          src="/images/yourgoshorty-logo.svg"
          alt="Light version of GoShorty logo."
        />
      </button>
      <div class="w-[90px] text-right">
        <navigation-menu-icon />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCustomerStore } from "~/stores/useCustomerStore";
const { checkOTPCode } = useApi();

const customerStore = useCustomerStore();
const goHome = () => {
  if (customerStore.customerFound && checkOTPCode) {
    useLinker().pushLink("/portal/");
    return;
  }
  useLinker().pushLink("/");
};

const goNewQuote = () => {
  if (customerStore.customerFound) {
    const quotePanel = document.getElementById("new-quote-panel");
    if (quotePanel) {
      quotePanel.scrollIntoView({ behavior: "smooth" });
    }
  } else {
    window.open("https://goshorty.co.uk/quote/");
  }
};
</script>
